import Form from 'mobx-react-form';
import plugins from './plugins';


const fields = {
    clientSecret: {
        label: 'Client Secret',
        rules: 'string|required',
    },
    clientId: {
        label: 'Client App Id',
        rules: 'string|required',
    },
};

class VantaForm extends Form {
    constructor(setup, options) {
        super({ fields, ...setup }, { plugins, ...options });
    }
}

export default VantaForm;
